import api, { handleResponse, handleError } from './api';

const notificationService = {
  /**
   * Get paginated notifications
   * @param {number} page - Page number (1-based)
   * @param {number} pageSize - Items per page
   * @param {{ family?: string|null, unread?: boolean }} [filter] - one inbox family
   *   ('signals' · 'people' · …, or 'all'/null for everything) and the UNREAD tab.
   *   The response's unreadByFamily / allCount ignore the filter.
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async getNotifications(page = 1, pageSize = 20, { family = null, unread = false } = {}) {
    try {
      const params = { page, pageSize };
      if (family && family !== 'all') params.family = family;
      if (unread) params.unread = true;
      const response = await api.get('/notifications', { params });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Get unread notification count
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async getUnreadCount() {
    try {
      const response = await api.get('/notifications/unread-count');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Mark a single notification as read
   * @param {string} id - Notification ID
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async markAsRead(id) {
    try {
      const response = await api.put(`/notifications/${id}/read`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Mark all notifications as read
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async markAllAsRead() {
    try {
      const response = await api.put('/notifications/read-all');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  // ---- Mutes (Phase 3c) ----
  async getMutes() {
    try { return handleResponse(await api.get('/notifications/mutes')); } catch (e) { return handleError(e); }
  },
  /** targetType: 'person' | 'club' */
  async addMute(targetType, targetId) {
    try { return handleResponse(await api.post('/notifications/mutes', { targetType, targetId })); } catch (e) { return handleError(e); }
  },
  async removeMute(targetType, targetId) {
    try { return handleResponse(await api.delete('/notifications/mutes', { params: { targetType, targetId } })); } catch (e) { return handleError(e); }
  },
};

export default notificationService;
